import { graphql } from 'src/graphql';

import { UserFields } from 'src/fragments/userFields.fragment';

export const UpdateMe = graphql(
  `
    mutation updateMe($user: UserInput!) {
      updateMe(user: $user) {
        ...UserFields
      }
    }
  `,
  [UserFields],
);
